import React from 'react';
import PropTypes from "prop-types";

const {connect} = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const {OKCover} = require('commonsComponents/OKCover');
const {OKButton} = require('commonsComponents/OKButton');
const {OKHeaderSubPage} = require("commonsComponents/OKHeaderSubPage");
const {ContentBox} = require('commonsComponents/contentBox');
const {OKBoxTitle} = require('commonsComponents/OKBoxTitle');
const {LoadingSection} = require('commonsComponents/loadingSection');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKTag = require('components/commons/OKTag/OKTag');
const OKModal = require('components/commons/OKModal/OKModal');
// @utils
const moment = require('moment');
const {formatText, FormattedText} = require('core/i18n').i18n;
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const classnames = require('classnames');
//@components
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;

const {TRUST_ON_DEVICE} = require('constants/operationTypes');
const informationIcon = require('assets/images/icon_important.svg');
const iconSuccess = require('assets/images/icon-success.svg');
const iconWarning = require('assets/images/icon-warning.svg');

const {
    toggleTrustDeviceStatus,
    requestDeviceInformation,
    setEnrolProcessError
} = require('actions/devices');

class DevicesTrustView extends React.Component {

    constructor(props) {
        super(props);

        this.handleGoBackToDevicesManagement = this.handleGoBackToDevicesManagement.bind(this);
        this.handleValidateCode = this.handleValidateCode.bind(this);
        this.getLastConnection = this.getLastConnection.bind(this);
        this.checkViewReady = this.checkViewReady.bind(this);
        this.getContentBoxProps = this.getContentBoxProps.bind(this);
        this.processHasSuccessOrError = this.processHasSuccessOrError.bind(this);
        this.getOkCoverBreadcrumbs = this.getOkCoverBreadcrumbs.bind(this);
        this.getAsideComponent = this.getAsideComponent.bind(this);
        this.handleCancelProcess = this.handleCancelProcess.bind(this);

        this.state = {
            ready: false,
            showModal: false
        };
    }

    componentWillMount() {
        const sid = window.location.pathname
            && window.location.pathname.split('/')
            && window.location.pathname.split('/')[4] || '';

        this.props.requestDeviceInformation(sid);
    }

    checkViewReady() {
        !this.state.ready
        && this.deviceHasInformation()
        && this.setState({
            ready: true
        }, () => this.checkEnrolDeviceStatus());
    }

    checkEnrolDeviceStatus() {
        this.props.device.enrol === false && this.props.setEnrolProcessError({
            error: {status: 400},
            text: '',
            body: {}
        });
    }

    handleGoBackToDevicesManagement() {
        this.setState({
            showModal: false
        }, () => this.props.history.push('/myprofile/devices'));
    }

    processHasSuccessOrError() {
        return this.hasSuccess() || this.hasError();
    }

    getContentBoxProps() {
        const titleStatus = [
            !this.deviceHasInformation() && 'noDeviceInformationTitle' || undefined,
            this.deviceHasInformation() && !this.processHasSuccessOrError() && 'trustDeviceViewTitle' || undefined,
            !this.props.trust && `untrustDevice${this.hasSuccess() ? 'Done' : 'Error'}Title` || undefined,
            this.props.trust && `trustDevice${this.hasSuccess() ? 'Done' : 'Error'}Title` || undefined,
            'noDeviceInformationTitle'
        ];

        return Object.assign({
            title: formatText(`manageDevices-${titleStatus.find(e => !!e)}`)
        }, (this.processHasSuccessOrError()) && {
            leftIcon: {'icon': this.props.success && iconSuccess || iconWarning},
            small: false,
            customClassName: this.processHasSuccessOrError() && 'success-container',
            titleSeparator: true
        }, this.hasError() && {
            extraContent: this.deviceHasInformation() && this.wrapErrorMessage() || this.getTagErrorMessage('noDeviceInformationText')
        });
    }

    wrapErrorMessage() {
        const errors = {
            400: 'badDeviceInputInformation',
            403: 'genericTrustDeviceProcessError',
            500: 'genericTrustDeviceProcessError'
        };
        const errorMsg = this.props.error.error && this.props.error.error.status || 500;
        return this.getTagErrorMessage(errors[errorMsg] || errors[500])
    }

    getTagErrorMessage(tag) {
        return (<OKTag content={formatText(`manageDevices-${tag}`)}
            type={'informative'}
            context="layered"/>)
    }

    handleValidateCode() {
        this.props.toggleTrustDeviceStatus(this.props.device.sid, !this.props.device.trusted)
    }

    hasError() {
        return this.props.error
            && Object.keys(this.props.error).length
            && Object.keys(this.props.error).every(key => ['error', 'body', 'text'].includes(key));
    }

    hasSuccess() {
        return this.props.success && this.props.success === true;
    }

    handleCancelProcess() {
        this.setState({showModal: true});
    }

    buildSignaturePatternFooterLayout() {
        return (<footer className="wizard-step__buttons">
            <div className="wizard-step__first-button">
                <OKButton
                    modifier="link-ghost"
                    onClick={this.handleCancelProcess}>
                    {<FormattedText format="firstUppercase"
                        value="manageDevices-cancel"/>}
                </OKButton>
            </div>
            <SignaturePatternButton
                loading={false}
                onClick={this.handleValidateCode}>
                <FormattedText value="manageDevices-confirm"/>
            </SignaturePatternButton>
        </footer>)
    }

    buildEndedProcessFooterLayout() {
        return (<footer className="wizard-step__buttons">
            <div className="wizard-step__fourth-button ">
                <OKButton
                    rightIcon={'icon-siguiente'}
                    modifier="link-complementary"
                    onClick={this.handleGoBackToDevicesManagement}
                >
                    {<FormattedText format="firstUppercase"
                        value="manageDevices-backToDevicesManagement"/>}
                </OKButton>
            </div>
        </footer>)
    }

    buildSuccessLayout() {
        return (<section className="trust-device__error-layout">
            {this.getDeviceInformation()}
            {this.buildEndedProcessFooterLayout()}
        </section>)
    }

    buildErrorLayout() {
        return (<section className="trust-device__success-layout">
            {this.buildEndedProcessFooterLayout()}
        </section>)
    }

    buildActionLayout() {
        return (<section className="trust-device__action-layout">
            {this.getDeviceInformation()}
            <hr className="trust-device__divider"/>
            <SignaturePattern
                operationType={TRUST_ON_DEVICE}
                operationParams={{}}
            />
            {this.buildSignaturePatternFooterLayout()}
        </section>)
    }

    deviceHasInformation() {
        return !!(this.props.device
            && this.props.device.hasOwnProperty('enrol')
            && this.props.device.hasOwnProperty('trusted')
            && this.props.device.hasOwnProperty('sid'))
    }

    renderContent() {
        const isFetching = this.props.isFetching,
            index = [
                isFetching && !this.deviceHasInformation(),
                isFetching && this.deviceHasInformation() && !this.processHasSuccessOrError(),
                !isFetching && this.deviceHasInformation() && !this.processHasSuccessOrError(),
                this.processHasSuccessOrError() && this.hasSuccess(),
                this.processHasSuccessOrError() && this.hasError(),
            ].findIndex(e => !!e);

        return [
            (() => <LoadingSection/>),
            (() => <LoadingSection/>),
            this.buildActionLayout.bind(this),
            this.buildSuccessLayout.bind(this),
            this.buildErrorLayout.bind(this)
        ][index > -1 && index || 3]()
    }

    getDeviceInformation() {
        return (<section>
            <header className="ok-divider ok-divider--section  "><span
                className="ok-divider__content"> <FormattedText
                    value={'manageDevices-deviceInformation'}/></span>
            </header>
            <OKInformativeList columns={2}>
                <OKInformativeListItem title={formatText('manageDevices-gridCellDevice')}>
                    <div className="card-transfer-money-to-checking-account-step1__value">
                        {this.props.device.model || formatText('manageDevices-noAvailableInformation')}
                    </div>
                </OKInformativeListItem>
                <OKInformativeListItem title={formatText('manageDevices-gridCellLastAccess')}>
                    <div className="card-transfer-money-to-checking-account-step1__value">
                        {this.getLastConnection()}
                    </div>
                </OKInformativeListItem>
            </OKInformativeList>
        </section>)
    }

    getLastConnection() {
        const lastConnection = this.props.device
            && this.props.device.sessions
            && this.props.device.sessions.length > 0
            && this.props.device.sessions[this.props.device.sessions.length - 1];

        return lastConnection && lastConnection.hasOwnProperty('active')
            ? moment(lastConnection.active && lastConnection.fhStart || lastConnection.fhEnd).format(DATE_FORMAT_TYPES['es'].DATE_FORMAT)
            : formatText('manageDevices-noAvailableInformation')
    }

    getAsideComponent() {
        return (<aside className="col-md-4 col-sm-4 grid-view--content-position-negative aside-banner">
            <ContentBox className="content-box--banner">
                <OKBoxTitle value={formatText('manageDevices-trustDevicesInformation')}
                    size="medium"
                    isNotSeparator={true}/>
                <section className="aside-banner__content">
                    <p className="body">
                        Lorem Ipsum dolor sit amet consectetur adipiscing
                        archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las
                        industrias
                        desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la
                        imprenta)
                    </p>
                    <img src={informationIcon}/>
                </section>
            </ContentBox>
        </aside>)
    }

    getOkCoverBreadcrumbs() {
        const url = this.props.trust ? 'addTrustDeviceBreadcrumb' : 'untrustDevice';
        return [
            {text: formatText("manageDevices-securityKeysBreadcrumbTitle"), url: "/myprofile/keys"},
            {text: formatText("manageDevices-manageDevicesBreadcrumbTitle"), url: '/myprofile/devices'},
            {text: formatText(`manageDevices-${url}`)}];
    }

    getMainLayoutClasses = () => classnames({
        'col-sm-8': true,
        [`col-md-${this.processHasSuccessOrError() && 9 || 8}`]: true,
        'col-xs-offset-1': this.processHasSuccessOrError()
    });

    render() {
        this.checkViewReady();
        return (
            <main className={'devices-trust-device'}>
                <OKCover extraClass="devices-view__head ok-cover--small ok-cover--pg" size="large">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.getOkCoverBreadcrumbs()}
                        finalTitle={formatText(`manageDevices-${this.props.trust ? 'trustOnDevice' : 'untrustDevice'}`)}
                        isSubtitleLeftCapital={false}
                        overlap={true}
                    >
                    </OKHeaderSubPage>
                </OKCover>
                <main className="grid-view__body row">
                    <div className={this.getMainLayoutClasses()}>
                        <div className="row grid-view--content-position-negative">
                            <ContentBox {...this.getContentBoxProps()}>
                                {this.renderContent()}
                            </ContentBox>
                        </div>
                    </div>
                    {!this.processHasSuccessOrError() && this.getAsideComponent() || null}
                </main>
                <OKModal
                    description={formatText('manageDevices-handleCancelProcessModalText')}
                    isOpen={this.state.showModal}
                    footerType="navigation"
                    onCloseCallback={() => this.setState({showModal: false})}
                    primaryButtonText={formatText('manageDevices-confirm')}
                    onPrimaryButtonClick={this.handleGoBackToDevicesManagement}
                    onSecondaryButtonClick={() => this.setState({showModal: false})}
                    secondaryButtonText="manageDevices-cancel"
                    title={formatText('manageDevices-handleCancelProcessModalTitle')}
                />
            </main>
        );
    }
}

DevicesTrustView.defaultProps = {
    success: false,
    trust: false,
    device: {},
    error: {},
    isFetching: true,
    requestDeviceInformation: () => {},
    toggleTrustDeviceStatus: () => {},
    setEnrolProcessError: () => {}
};

DevicesTrustView.propTypes = {
    success: PropTypes.bool,
    trust: PropTypes.bool,
    device: PropTypes.object,
    history: PropTypes.object.isRequired,
    toggleTrustDeviceStatus: PropTypes.func,
    requestDeviceInformation: PropTypes.func,
    setEnrolProcessError: PropTypes.func,
    error: PropTypes.object,
    isFetching: PropTypes.bool
};

const mapStateToProps = (state) => ({
    success: state.devices.getIn(['trust', 'success']),
    trust: state.devices.getIn(['trust', 'enrol']),
    device: state.devices.getIn(['trust', 'device']).toJSON(),
    error: state.devices.getIn(['trust', 'error']).toJSON(),
    isFetching: state.devices.getIn(['trust', 'isFetching'])
});

const mapDispatchToProps = {
    toggleTrustDeviceStatus,
    requestDeviceInformation,
    setEnrolProcessError
};


module.exports.DevicesTrustView = connect(mapStateToProps, mapDispatchToProps)(withRouter(DevicesTrustView));

